'use client';

import { useEffect, useState } from 'react';

const Loader = () => {
  const [progress, setProgress] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const present = { value: 0 };

    const timer = setInterval(() => {
      const newValue = present.value + 1;
      setProgress(newValue);
      if (newValue >= 100) {
        clearInterval(timer);
        setIsLoaded(true);
      }
      present.value = newValue;
    }, 15);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const strokeDashoffset = 310 - (progress / 100) * 310;

  return (
    <div
      className={`loader relative h-screen w-screen bg-white transition-opacity duration-500 ${
        isLoaded ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        className="absolute bottom-0 left-0 right-0 top-0 m-auto flex h-40 w-40 md:h-72 md:w-72"
        preserveAspectRatio="xMinYMin meet"
        fill="none"
      >
        <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--theme-color)" />
          <stop offset="50%" stopColor="var(--border-color)" />
          <stop offset="100%" stopColor="var(--assistant-color)" />
        </linearGradient>
        <path
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          style={{
            strokeDasharray: '310px',
            strokeDashoffset: `${strokeDashoffset}px`,
          }}
        />
      </svg>
      <div className="absolute bottom-0 left-0 right-0 top-0 m-auto flex h-40 w-40 items-center justify-center rounded-full border border-blue-grey md:h-72 md:w-72">
        <p className="text-5xl font-medium text-blue-grey md:text-7xl">{progress.toFixed(0)}</p>
      </div>
    </div>
  );
};

export default Loader;
